import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'valores'

const ValoresRepository = {
  general () {
    return ApiService.get(`${REPOSITORY_URL}/general`)
  },
}

export default ValoresRepository
